import { toast } from 'react-toastify';
import store from '@/app/store';
import { logout } from '@/features/Auth/authSlice';
import { clearSession } from '@/shared/utils/clearSession';

/**
 * Handles session expiration by clearing all client-side caches/storage,
 * showing a toast notification, and dispatching the Redux logout action.
 *
 * Called from the axios 401 interceptor (and anywhere else that needs to
 * end the session due to an unrecoverable auth failure). Uses a unique
 * `toastId` to prevent duplicate toasts when multiple handlers trigger
 * simultaneously (e.g. several in-flight requests all 401 at once).
 */
export const handleSessionExpired = async () => {
  toast.error('Session expired, please log in again', {
    toastId: 'session-expired',
  });
  // Dispatch first so the UI flips to logged-out immediately; the async
  // storage/cache teardown runs in the background. Reducer is now a pure
  // state mutation (no I/O), so this is effectively synchronous.
  store.dispatch(logout());
  await clearSession();
};
